import {
  type CeilingHeight,
  type Controls,
  type SurfaceType,
} from '#packages/data-collection/models/audit-lighting-count-form';

export const CeilingHeightLabel: Record<CeilingHeight, string> = {
  'lt-12-inch': "<12'",
  '12-to-30-inch': "12'-30'",
  'gt-30-inch': "30'+",
};

export const SurfaceTypeLabel: Record<SurfaceType, string> = {
  open: 'Open',
  drywall: 'Drywall',
  't-bar': 'T-bar',
  'q-deck': 'Q-deck',
  soffit: 'Soffit',
  concrete: 'Concrete',
  wood: 'Plywood/Wood',
  'ceiling-tiles': 'Ceiling Tiles',
};

export const ControlsLabel: Record<Controls, string> = {
  breaker: 'Breaker',
  switch: 'Switch',
  occ_sensor: 'Occ. Sensor',
  dimmer: 'Dimmer',
  low_voltage: 'Low Voltage',
  BAS: 'BAS',
  daylight_sensor: 'Daylight Sensor',
  timer: 'Timer',
};
